import React, { useState, useRef, useEffect } from 'react';
import { graphql } from 'gatsby';

import RichText from '../Global/RichText';
import { KontentRichText } from '../../../types/KontentProps';
//@ts-ignore
import * as styles from './blog-references.module.css';
import ShowMoreArrow from '../Global/ShowMoreArrow';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

interface Props {
    kontentItemId?: string;
    references?: KontentRichText;
}

const BlogReferences: React.FC<Props> = ({
    kontentItemId,
    references,
    ...props
}) => {
    const breakpoints = useBreakpoint();
    const refDiv = useRef(null);
    const [refStyle, setStyle] = useState(styles.mobile);
    const [buttonStyle, setButtonStyle] = useState(styles.buttonShow);
    const showViewMoreButton = () => {
        return (
            <div className={buttonStyle}>
                <ShowMoreArrow
                    btnText="Show More"
                    strokeColor="#505251"
                    handleClick={handleViewMoreClick}
                    transform={'0'}
                />
            </div>
        );
    };

    const handleViewMoreClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        setStyle(styles.expanded);
        setButtonStyle(styles.buttonHide);
    };

    useEffect(() => {
        if (refDiv?.current?.offsetHeight < 65) {
            setStyle(styles.expanded);
            setButtonStyle(styles.buttonHide);
        }
    }, []);

    return (
        <section
            className={styles.wrapper}
            data-kontent-item-id={kontentItemId}
        >
            {references && (
                <div id="references" className={refStyle} ref={refDiv}>
                    {RichText(
                        references,
                        false,
                        undefined,
                        undefined,
                        'references'
                    )}
                </div>
            )}
            {showViewMoreButton()}
        </section>
    );
};

export default BlogReferences;

export const fragmentBlogReferences = graphql`
    fragment BlogReferences on kontent_item_component___blog_references {
        id
        elements {
            references {
                ...kontentRichText
            }
        }
    }
`;
